import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectIsAdmin } from "../../store/slices/session";

export default function IndexPage() {
	const session = useAppSelector(state => state.session);
	const isAdmin = selectIsAdmin(session);

	if (isAdmin) {
		return <Navigate to="dashboard" replace />;
	} else {
		return <Navigate to="profile" replace />;
	}
}
